export const generateFieldName = (prefix: string, id: string) => `${prefix}-${id}`;

export const getFieldName = (fieldName: string, id?: string) =>
  id ? generateFieldName(fieldName, id) : fieldName;
